import {
  adjectives,
  animals,
  colors,
  uniqueNamesGenerator,
} from "unique-names-generator";
import { toast } from "react-toastify";

const genderOptions = [
  { value: "female", label: "Female" },
  { value: "male", label: "Male" },
  { value: "transman", label: "Transman" },
  { value: "transwoman", label: "Transwoman" },
  { value: "nonbinary", label: "Non-Binary" },
  { value: "dontknow", label: "Don't Know" },
  { value: "prefernot", label: "Prefer Not to Say" },
  { value: "other", label: "Other" },
];

const ageOptions = [
  { value: "<18", label: "Under 18" },
  { value: "18-24", label: "18-24" },
  { value: "25-34", label: "25-34" },
  { value: "35-44", label: "35-44" },
  { value: "45-54", label: "45-54" },
  { value: "55-64", label: "55-64" },
  { value: "65-74", label: "65-74" },
  { value: "75-84", label: "75-84" },
  { value: "85+", label: "85+" },
];

const ethnicityOptions = [
  {
    value: "black/black-british/caribbean/african",
    label: "Black, Black British, Caribbean or African",
  },
  { value: "arab", label: "Arab" },
  { value: "asian/asian-british", label: "Asian or Asian British" },
  { value: "mixed/multiple", label: "Mixed or Multiple Ethnic Groups" },
  { value: "white", label: "White" },
  { value: "other", label: "Other Ethnic Group" },
  { value: "prefernot", label: "Prefer Not to Say" },
];

const countryOptions = [
  { value: "united-kingdom", label: "United Kingdom" },
  { value: "united-states", label: "United States" },
  { value: "afghanistan", label: "Afghanistan" },
  { value: "albania", label: "Albania" },
  { value: "algeria", label: "Algeria" },
  { value: "andorra", label: "Andorra" },
  { value: "angola", label: "Angola" },
  { value: "antigua-and-dep", label: "Antigua and Deps" },
  { value: "argentina", label: "Argentina" },
  { value: "armenia", label: "Armenia" },
  { value: "australia", label: "Australia" },
  { value: "austria", label: "Austria" },
  { value: "azerbaijan", label: "Azerbaijan" },
  { value: "bahamas", label: "Bahamas" },
  { value: "bahrain", label: "Bahrain" },
  { value: "bangladesh", label: "Bangladesh" },
  { value: "barbados", label: "Barbados" },
  { value: "belarus", label: "Belarus" },
  { value: "belgium", label: "Belgium" },
  { value: "belize", label: "Belize" },
  { value: "benin", label: "Benin" },
  { value: "bhutan", label: "Bhutan" },
  { value: "bolivia", label: "Bolivia" },
  { value: "bosnia-herzegovina", label: "Bosnia Herzegovina" },
  { value: "botswana", label: "Botswana" },
  { value: "brazil", label: "Brazil" },
  { value: "brunei", label: "Brunei" },
  { value: "bulgaria", label: "Bulgaria" },
  { value: "burkina", label: "Burkina" },
  { value: "burundi", label: "Burundi" },
  { value: "cambodia", label: "Cambodia" },
  { value: "cameroon", label: "Cameroon" },
  { value: "canada", label: "Canada" },
  { value: "cape-verde", label: "Cape Verde" },
  { value: "central-african-rep", label: "Central African Rep" },
  { value: "chad", label: "Chad" },
  { value: "chile", label: "Chile" },
  { value: "china", label: "China" },
  { value: "colombia", label: "Colombia" },
  { value: "comoros", label: "Comoros" },
  { value: "congo", label: "Congo" },
  { value: "congo-dem-rep", label: "Congo {Democratic Rep}" },
  { value: "costa-rica", label: "Costa Rica" },
  { value: "croatia", label: "Croatia" },
  { value: "cuba", label: "Cuba" },
  { value: "cyprus", label: "Cyprus" },
  { value: "czech-republic", label: "Czech Republic" },
  { value: "denmark", label: "Denmark" },
  { value: "djibouti", label: "Djibouti" },
  { value: "dominica", label: "Dominica" },
  { value: "dominican-republic", label: "Dominican Republic" },
  { value: "east-timor", label: "East Timor" },
  { value: "ecuador", label: "Ecuador" },
  { value: "egypt", label: "Egypt" },
  { value: "el-salvador", label: "El Salvador" },
  { value: "equatorial-guinea", label: "Equatorial Guinea" },
  { value: "eritrea", label: "Eritrea" },
  { value: "estonia", label: "Estonia" },
  { value: "ethiopia", label: "Ethiopia" },
  { value: "fiji", label: "Fiji" },
  { value: "finland", label: "Finland" },
  { value: "france", label: "France" },
  { value: "gabon", label: "Gabon" },
  { value: "gambia", label: "Gambia" },
  { value: "georgia", label: "Georgia" },
  { value: "germany", label: "Germany" },
  { value: "ghana", label: "Ghana" },
  { value: "greece", label: "Greece" },
  { value: "grenada", label: "Grenada" },
  { value: "guatemala", label: "Guatemala" },
  { value: "guinea", label: "Guinea" },
  { value: "guinea-bissau", label: "Guinea-Bissau" },
  { value: "guyana", label: "Guyana" },
  { value: "haiti", label: "Haiti" },
  { value: "honduras", label: "Honduras" },
  { value: "hungary", label: "Hungary" },
  { value: "iceland", label: "Iceland" },
  { value: "india", label: "India" },
  { value: "indonesia", label: "Indonesia" },
  { value: "iran", label: "Iran" },
  { value: "iraq", label: "Iraq" },
  { value: "ireland", label: "Ireland {Republic}" },
  { value: "israel", label: "Israel" },
  { value: "italy", label: "Italy" },
  { value: "ivory-coast", label: "Ivory Coast" },
  { value: "jamaica", label: "Jamaica" },
  { value: "japan", label: "Japan" },
  { value: "jordan", label: "Jordan" },
  { value: "kazakhstan", label: "Kazakhstan" },
  { value: "kenya", label: "Kenya" },
  { value: "kiribati", label: "Kiribati" },
  { value: "korea-north", label: "Korea North" },
  { value: "korea-south", label: "Korea South" },
  { value: "kosovo", label: "Kosovo" },
  { value: "kuwait", label: "Kuwait" },
  { value: "kyrgyzstan", label: "Kyrgyzstan" },
  { value: "laos", label: "Laos" },
  { value: "latvia", label: "Latvia" },
  { value: "lebanon", label: "Lebanon" },
  { value: "lesotho", label: "Lesotho" },
  { value: "liberia", label: "Liberia" },
  { value: "libya", label: "Libya" },
  { value: "liechtenstein", label: "Liechtenstein" },
  { value: "lithuania", label: "Lithuania" },
  { value: "luxembourg", label: "Luxembourg" },
  { value: "macedonia", label: "Macedonia" },
  { value: "madagascar", label: "Madagascar" },
  { value: "malawi", label: "Malawi" },
  { value: "malaysia", label: "Malaysia" },
  { value: "maldives", label: "Maldives" },
  { value: "mali", label: "Mali" },
  { value: "malta", label: "Malta" },
  { value: "marshall-islands", label: "Marshall Islands" },
  { value: "mauritania", label: "Mauritania" },
  { value: "mauritius", label: "Mauritius" },
  { value: "mexico", label: "Mexico" },
  { value: "micronesia", label: "Micronesia" },
  { value: "moldova", label: "Moldova" },
  { value: "monaco", label: "Monaco" },
  { value: "mongolia", label: "Mongolia" },
  { value: "montenegro", label: "Montenegro" },
  { value: "morocco", label: "Morocco" },
  { value: "mozambique", label: "Mozambique" },
  { value: "myanmar", label: "Myanmar" },
  { value: "namibia", label: "Namibia" },
  { value: "nauru", label: "Nauru" },
  { value: "nepal", label: "Nepal" },
  { value: "netherlands", label: "Netherlands" },
  { value: "new-zealand", label: "New Zealand" },
  { value: "nicaragua", label: "Nicaragua" },
  { value: "niger", label: "Niger" },
  { value: "nigeria", label: "Nigeria" },
  { value: "norway", label: "Norway" },
  { value: "oman", label: "Oman" },
  { value: "pakistan", label: "Pakistan" },
  { value: "palau", label: "Palau" },
  { value: "panama", label: "Panama" },
  { value: "papua-new-guinea", label: "Papua New Guinea" },
  { value: "paraguay", label: "Paraguay" },
  { value: "peru", label: "Peru" },
  { value: "philippines", label: "Philippines" },
  { value: "poland", label: "Poland" },
  { value: "portugal", label: "Portugal" },
  { value: "qatar", label: "Qatar" },
  { value: "romania", label: "Romania" },
  { value: "russia", label: "Russia" },
  { value: "rwanda", label: "Rwanda" },
  { value: "st-kitts-and-nevis", label: "St Kitts & Nevis" },
  { value: "st-lucia", label: "St Lucia" },
  {
    value: "saint-vincent-and-the-grenadines",
    label: "Saint Vincent & the Grenadines",
  },
  { value: "samoa", label: "Samoa" },
  { value: "san-marino", label: "San Marino" },
  { value: "sao-tome-and-principe", label: "Sao Tome & Principe" },
  { value: "saudi-arabia", label: "Saudi Arabia" },
  { value: "senegal", label: "Senegal" },
  { value: "serbia", label: "Serbia" },
  { value: "seychelles", label: "Seychelles" },
  { value: "sierra-leone", label: "Sierra Leone" },
  { value: "singapore", label: "Singapore" },
  { value: "slovakia", label: "Slovakia" },
  { value: "slovenia", label: "Slovenia" },
  { value: "solomon-islands", label: "Solomon Islands" },
  { value: "somalia", label: "Somalia" },
  { value: "south-africa", label: "South Africa" },
  { value: "south-sudan", label: "South Sudan" },
  { value: "spain", label: "Spain" },
  { value: "sri-lanka", label: "Sri Lanka" },
  { value: "sudan", label: "Sudan" },
  { value: "suriname", label: "Suriname" },
  { value: "swaziland", label: "Swaziland" },
  { value: "sweden", label: "Sweden" },
  { value: "switzerland", label: "Switzerland" },
  { value: "syria", label: "Syria" },
  { value: "taiwan", label: "Taiwan" },
  { value: "tajikistan", label: "Tajikistan" },
  { value: "tanzania", label: "Tanzania" },
  { value: "thailand", label: "Thailand" },
  { value: "togo", label: "Togo" },
  { value: "tonga", label: "Tonga" },
  { value: "trinidad-and-tobago", label: "Trinidad & Tobago" },
  { value: "tunisia", label: "Tunisia" },
  { value: "turkey", label: "Turkey" },
  { value: "turkmenistan", label: "Turkmenistan" },
  { value: "tuvalu", label: "Tuvalu" },
  { value: "uganda", label: "Uganda" },
  { value: "ukraine", label: "Ukraine" },
  { value: "united-arab-emirates", label: "United Arab Emirates" },
  { value: "uruguay", label: "Uruguay" },
  { value: "uzbekistan", label: "Uzbekistan" },
  { value: "vanuatu", label: "Vanuatu" },
  { value: "vatican-city", label: "Vatican City" },
  { value: "venezuela", label: "Venezuela" },
  { value: "vietnam", label: "Vietnam" },
  { value: "yemen", label: "Yemen" },
  { value: "zambia", label: "Zambia" },
  { value: "zimbabwe", label: "Zimbabwe" },
];

const nameRegex = new RegExp(
  "^[a-zA-Z\\xC0-\\uFFFF]+([ \\-']{0,1}[a-zA-Z\\xC0-\\uFFFF]+){0,2}[.]{0,1}$"
);
const postcodeRegex = new RegExp("^\\w+[- ]?\\w+$");
const emailRegex = new RegExp("^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$");
const passwordRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");

const generateDisplayName = () => {
  const username = uniqueNamesGenerator({
    dictionaries: [adjectives, colors, animals],
    separator: "",
    style: "lowerCase",
    length: 2,
  });

  return username;
};

const getSelectedLabel = (value, options) => {
  let selectedOption = options.find((option) => option.value === value);

  return selectedOption ? selectedOption.label : "";
};

const validateName = (name) => {
  let isValid = nameRegex.test(name);
  let isEmpty = name.length === 0 || name === "" || name === null;

  if (isEmpty) {
    toast.error("Name is required");
  } else if (!isValid) {
    toast.error("Name is invalid");
  }

  return isValid && !isEmpty;
};

const validateGender = (gender) => {
  let isValid = genderOptions.some((option) => gender === option.value);
  let isEmpty = gender.length === 0 || gender === "" || gender === null;

  if (isEmpty) {
    toast.error("Gender is required");
  } else if (!isValid) {
    toast.error("Gender is invalid");
  }

  return isValid && !isEmpty;
};

const validateAgeRange = (ageRange) => {
  let isValid = ageOptions.some((option) => ageRange === option.value);
  let isEmpty = ageRange.length === 0 || ageRange === "" || ageRange === null;

  if (isEmpty) {
    toast.error("Age is required");
  } else if (!isValid) {
    toast.error("Age is invalid");
  }

  return isValid && !isEmpty;
};

const validateEthnicity = (ethnicity) => {
  let isValid = ethnicityOptions.some((option) => ethnicity === option.value);
  let isEmpty =
    ethnicity.length === 0 || ethnicity === "" || ethnicity === null;

  if (isEmpty) {
    toast.error("Ethnicity is required");
  } else if (!isValid) {
    toast.error("Ethnicity is invalid");
  }

  return isValid && !isEmpty;
};

const validateCountry = (country) => {
  let isValid = countryOptions.some((option) => country === option.value);
  let isEmpty = country.length === 0 || country === "" || country === null;

  if (isEmpty) {
    toast.error("Country is required");
  } else if (!isValid) {
    toast.error("Country is invalid");
  }

  return isValid && !isEmpty;
};

const validatePostcode = (postcode) => {
  let isValid = postcodeRegex.test(postcode);
  let isEmpty = postcode.length === 0 || postcode === "" || postcode === null;

  if (isEmpty) {
    toast.error("Postcode is required");
  } else if (!isValid) {
    toast.error("Postcode is invalid");
  }

  return isValid && !isEmpty;
};

const validateDisplayName = (displayName) => {
  let isValid = displayName.length >= 3;
  let isEmpty = displayName === "" || displayName === null;

  if (isEmpty) {
    toast.error("Display name is required");
  } else if (!isValid) {
    toast.error("Display name is invalid");
  }

  return isValid && !isEmpty;
};

const validateEmail = (email) => {
  let isValid = emailRegex.test(email);
  let isEmpty = email.length === 0 || email === "" || email === null;

  if (isEmpty) {
    toast.error("Email is required");
  } else if (!isValid) {
    toast.error("Email is invalid");
  }

  return isValid && !isEmpty;
};

const validatePassword = (password, confirmPassword = "NA") => {
  let isEmptyPassword =
    password.length === 0 || password === "" || password === null;
  let isEmptyConfPassword =
    confirmPassword === "NA"
      ? false
      : confirmPassword.length === 0 ||
        confirmPassword === "" ||
        confirmPassword === null;

  let isValidPassword = passwordRegex.test(password);
  let isValidConfPassword =
    confirmPassword === "NA" ? true : passwordRegex.test(confirmPassword);

  let isEmpty = isEmptyPassword && isEmptyConfPassword;
  let isValid = isValidPassword && isValidConfPassword;
  let isMatch = confirmPassword === "NA" ? true : password === confirmPassword;

  if (isEmptyPassword) {
    toast.error("Password is required");
  } else {
    if (!isValidPassword) {
      toast.error("Password is invalid");
    }
  }

  if (isEmptyConfPassword) {
    toast.error("Confirm Password is required");
  } else {
    if (!isValidConfPassword) {
      toast.error("Confirm Password is invalid");
    }
  }

  if (!isMatch && isValidPassword && isValidPassword) {
    toast.error("Passwords do not match");
  }

  if (
    !isValidPassword ||
    !isValidConfPassword ||
    isEmptyPassword ||
    isEmptyConfPassword
  ) {
    toast.info(
      "Password must contain at least 8 characters, 1 uppercase, 1 lowercase and 1 number",
      {
        toastId: "info",
      }
    );
  }

  return isValid && !isEmpty && isMatch;
};

const validateTerms = (termsData, termsCond) => {
  let isValid = termsData === termsCond && termsData === true;
  let isEmpty = termsData === "" || termsData === null;

  if (isEmpty || !isValid) {
    toast.error("Terms and conditions must be accepted");
  }

  return isValid && !isEmpty;
};

const validateSignIn = (payload) => {
  let { email, password } = payload;

  let emailValid = validateEmail(email);
  let passwordValid = validatePassword(password);

  return emailValid && passwordValid;
};

const validateSignUp = (payload) => {
  let {
    name,
    gender,
    age_range,
    ethnicity,
    country,
    postcode,
    display_name,
    email,
    password,
    conf_password,
    terms_data,
    terms_cond,
  } = payload;

  let nameValid = validateName(name);
  let genderValid = validateGender(gender);
  let ageRangeValid = validateAgeRange(age_range);
  let ethnicityValid = validateEthnicity(ethnicity);
  let countryValid = validateCountry(country);
  let postcodeValid = validatePostcode(postcode);
  let displayNameValid = validateDisplayName(display_name);
  let emailValid = validateEmail(email);
  let passwordValid = validatePassword(password, conf_password);
  let termsValid = validateTerms(terms_data, terms_cond);

  return (
    nameValid &&
    genderValid &&
    ageRangeValid &&
    ethnicityValid &&
    countryValid &&
    postcodeValid &&
    displayNameValid &&
    emailValid &&
    passwordValid &&
    termsValid
  );
};

const validateUpdate = (payload, update = "user") => {
  if (update === "user") {
    let { name, gender, age_range, ethnicity, country, postcode, email } =
      payload;

    let nameValid = validateName(name);
    let genderValid = validateGender(gender);
    let ageRangeValid = validateAgeRange(age_range);
    let ethnicityValid = validateEthnicity(ethnicity);
    let countryValid = validateCountry(country);
    let postcodeValid = validatePostcode(postcode);
    let emailValid = validateEmail(email);

    return (
      nameValid &&
      genderValid &&
      ageRangeValid &&
      ethnicityValid &&
      countryValid &&
      postcodeValid &&
      emailValid
    );
  } else if (update === "password") {
    let { old_assword, new_password, conf_Password } = payload;

    let oldPasswordValid = validatePassword(old_assword);
    let newPasswordValid = validatePassword(new_password, conf_Password);

    return oldPasswordValid && newPasswordValid;
  }
};

export {
  genderOptions,
  ageOptions,
  ethnicityOptions,
  countryOptions,
  generateDisplayName,
  getSelectedLabel,
  validateSignIn,
  validateSignUp,
  validateUpdate,
};
